import { GetterTree } from "vuex";
import { ICategoryState } from "@/services/store/category/category-types";
import { RootState } from "@/services/store/root-state";
import { generateBaseGettersFor } from "@/services/store/utils/base-generators";
import { ICategory } from "@/services/data/category/category.interface";

export const getters: GetterTree<ICategoryState, RootState> =
  generateBaseGettersFor<ICategoryState, ICategory>("categories");
